import { render, staticRenderFns } from "./TabAutoApproved.vue?vue&type=template&id=a92c3cbc"
import script from "./TabAutoApproved.vue?vue&type=script&lang=js"
export * from "./TabAutoApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports